interface Cell {
  type: string;
  sourceCode?: string;
  sourceXml?: string;
  module?: string;
  defaultCode?: string;
  defaultXml?: string;
  multipleSourceCodes?: {
    sourceCode?: string;
    sourceXml?: string;
    defaultCode?: string;
    defaultXml?: string;
  }[];
}

interface Chapter {
  name: string;
  nameEn: string;
  cells: Cell[];
  subchapters?: Chapter[];
}

interface ModuleData {
  namePrefix: string;
  namePrefixEn: string;
  name: string;
  nameEn: string;
  chapters: Chapter[];
}

interface ExtractedCodeData {
  sourceCode?: string;
  sourceXml?: string;
  defaultCode?: string;
  defaultXml?: string;
}

export function extractSourceCodes(data: ModuleData): ExtractedCodeData[] {
  const result: ExtractedCodeData[] = [];

  function traverseChapters(chapters: Chapter[]) {
    for (const chapter of chapters) {
      // Check for cells where type is "Code"
      for (const cell of chapter.cells || []) {
        if (cell.type === "Code" && cell.sourceCode) {
          if (cell.multipleSourceCodes !== undefined) {
            for (const multipleSourceCode of cell.multipleSourceCodes) {
              result.push({
                sourceCode: multipleSourceCode.sourceCode,
                sourceXml: multipleSourceCode.sourceXml,
                defaultCode: multipleSourceCode.defaultCode,
                defaultXml: multipleSourceCode.defaultXml,
              });
            }
          } else {
            result.push({
              sourceCode: cell.sourceCode,
              sourceXml: cell.sourceXml,
              defaultCode: cell.defaultCode,
              defaultXml: cell.defaultXml,
            });
          }
        }
      }

      // If there are subchapters, traverse them recursively
      if (chapter.subchapters) {
        traverseChapters(chapter.subchapters);
      }
    }
  }

  // Start traversing from the main chapters
  traverseChapters(data.chapters);

  return result;
}
